import React, { useEffect, useRef, useState } from "react";
import TheoryContentEditor from "../TheoryContentEditor";
import {
  parseTheoryContent,
  serializeTheoryBlocks,
  createEmptyBlock,
  BLOCK_TYPES,
} from "../../../../utils/theoryContentUtils";

export default function AddTheoryTopic({ formData, setFormData }) {
  const lastSerializedFromBlocksRef = useRef("[]");

  // Initialize blocks state - start with one empty paragraph block
  const [blocks, setBlocks] = useState(() => {
    // If formData already has theoryContent, parse it into blocks
    if (formData.theoryContent && formData.theoryContent.length > 0) {
      const existingContent = formData.theoryContent.filter(
        (c) => c && c.trim()
      );
      if (existingContent.length > 0) {
        return parseTheoryContent(existingContent);
      }
    }
    // Default: start with one empty paragraph
    return [createEmptyBlock(BLOCK_TYPES.PARAGRAPH)];
  });

  // If formData.theoryContent changes externally (e.g. JSON import), update blocks.
  // Guard against loops: ignore changes that we ourselves just wrote from blocks.
  useEffect(() => {
    const theoryContent = Array.isArray(formData?.theoryContent)
      ? formData.theoryContent
      : [];
    const sanitized = theoryContent.filter((c) => c && String(c).trim());
    const key = JSON.stringify(sanitized.map((c) => String(c)));

    if (key === lastSerializedFromBlocksRef.current) return;

    if (sanitized.length === 0) {
      setBlocks([createEmptyBlock(BLOCK_TYPES.PARAGRAPH)]);
      return;
    }

    setBlocks(parseTheoryContent(sanitized.map((c) => String(c))));
  }, [formData?.theoryContent]);

  // Sync blocks back to formData.theoryContent whenever blocks change
  useEffect(() => {
    const serialized = serializeTheoryBlocks(blocks);
    lastSerializedFromBlocksRef.current = JSON.stringify(serialized);
    setFormData((prev) => ({
      ...prev,
      theoryContent: serialized.length > 0 ? serialized : [""],
    }));
  }, [blocks, setFormData]);

  return <TheoryContentEditor blocks={blocks} setBlocks={setBlocks} />;
}
